export const use_registration = true
export const use_credits = false
export const use_payconiq = true
export const use_cash = true
export const use_drinkingcard = false
export const cents_per_vakje = 50
